import React from "react";
import './index.css'

function Loader() {
    return (
        <div className="cdLoaderContainer">
            <div className="cdLoader">
                <div/>
                <div/>
            </div>
        </div>
    )
}

export default Loader;
